import React from 'react';
import { scrollContainerClassName } from '../../constants';
// TODO: pass initialPosition ??
function ScrollContainer({ className: _className = '', children, onScroll = () => void 0, scrollRef, }) {
    const scrollContainerClass = React.useMemo(() => `${scrollContainerClassName} ${_className}`, [_className]);
    return (React.createElement("div", { className: scrollContainerClass, onScroll: onScroll, ref: scrollRef }, children));
}
export default ScrollContainer;
